module.exports = __webpack_public_path__ + "static/media/18ECA11.753f0bad.jpg";